import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
/*
Ver documentación en: https://vuex.vuejs.org/api/#mutations
*/

const SecurityParamsVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "SecurityParams/v1.0/",
    $_securityParams: [],
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    currentSecurityParams: (state) => state.$_securityParams,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initSecurityParams({ commit }) {
      var securityParams = {
        daysInactivity: null,
        daysDuePass: null,
        hoursForValidation: null,
        passwordSavedCount: null,
        attemptCountBlock: null,
        hoursForResetPass: null,
        minutesRestartAttempts: null,
        minLengthPass: null,
        maxLengthPass: null,
        reqUpperPass: false,
        reqLowerPass: false,
        reqNumberPass: false,
        reqSpecialCharacterPass: false,
        aceptSpacePass: false,
        regexPass: "",
        applications: {
          id: 0
        }
      };

      commit("SET_SECURITY_PARAMS", securityParams);
    },
    clearSecurityParams({ commit }) {
      commit("SET_SECURITY_PARAMS", []);
    },
    setSecurityParams({ commit }, securityParams) {
      commit("SET_SECURITY_PARAMS", securityParams);
    },
    async getSecurityParams({ commit, dispatch, state, rootGetters }) {
      var authUrl = rootGetters.authUrl;
      var actionLink =
        authUrl +
        state.$_moduleApiPath +
        "GetSecurityParamsAsync" +
        ":" +
        rootGetters.applicationId;
      var axiosConfig = rootGetters.authaxiosConfig;

      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_SECURITY_PARAMS", response.data.data);
      } catch (error) {
        commit("SET_SECURITY_PARAMS", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async saveSecurityParams({ commit, dispatch, state, rootGetters }, params) {
      var authUrl = rootGetters.authUrl;
      var actionLink =
        authUrl + state.$_moduleApiPath + "SaveSecurityParamsAsync";
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        params.applications = { id: rootGetters.applicationId };
        await axios.post(actionLink, params, axiosConfig);
        commit("SET_SECURITY_PARAMS", params);
      } catch (error) {
        commit("SET_SECURITY_PARAMS", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_SECURITY_PARAMS(state, value) {
      state.$_securityParams = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default SecurityParamsVuexModule;
